import React, { Component } from 'react';
import './style.css';
import { Trans, translate } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { RIETextArea } from 'riek';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowRight,
  faArrowUp,
  faPen
} from '@fortawesome/free-solid-svg-icons';

class Term extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      suggestedTerms: []
    };
    this.handleChange = this.handleChange.bind(this);
    this.fetchSuggestedTerms = this.fetchSuggestedTerms.bind(this);
  }

  componentDidMount() {
    this.fetchSuggestedTerms();
  }

  handleChange(event) {
    this.setState({
      value: event.target.value
    });
  }

  fetchSuggestedTerms() {
    const {
      story,
      i18n: { language: lang }
    } = this.props;
    console.log(lang);

    const payload = {
      method: 'POST',
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        story,
        lang
      })
    };

    fetch(
      process.env.REACT_APP_API_URL + '/backend/interview/api/story-aspect/',
      payload
    )
      .then(response => response.json())
      .then(json => this.setState({ suggestedTerms: json.result }))
      .catch(err => console.log('Error while fetching terms:', err));
  }

  render() {
    const { t } = this.props;
    let description;
    const name1 = this.props.pair.projectObjects[0].name;
    const name2 = this.props.pair.projectObjects[1].name;
    if (this.props.adjective === 'similar') {
      description = (
        <Trans i18nKey="similarNew">
          Thanks for your story! In it, what is the{' '}
          <b>most important characteristic</b>
          that <b>"{{ name1 }}"</b> and <b>"{{ name2 }}"</b> have in common?
        </Trans>
      );
    }
    if (this.props.adjective === 'different') {
      description = (
        <Trans i18nKey="differentNew">
          Thanks for your story! In it, what is the{' '}
          <b>most important characteristic</b>
          that distinguishes <b>"{{ name1 }}"</b> from <b>"{{ name2 }}"</b>?
        </Trans>
      );
    }

    let skip = () => {
      const nextPath = this.props.skip(this.props.pair);
      if (this.props.history.canGo(1)) {
        this.props.history.goForward();
      } else {
        this.props.history.push(nextPath);
      }
    };

    let suggestedTermsContainer;
    if (this.state.suggestedTerms.length > 0) {
      suggestedTermsContainer = (
        <div>
          <small className="d-block mt-4 mb-3 text-muted">
            Suggested terms:
          </small>
          <div className="suggested-options">
            {this.state.suggestedTerms.map(term => (
              <button
                className="btn-suggested-option"
                onClick={() => this.setState((prev) => ({ value: `${prev.value} ${term}`.trim() }))}
              >
                {term}
                <FontAwesomeIcon className="arrow-up-left" icon={faArrowUp} />
              </button>
            ))}
          </div>
        </div>
      );
    }

    return (
      <div className="card-body">
        <div className="story-content">
          <RIETextArea
            value={this.props.story}
            propName="story"
            className="story-editor"
            change={data => this.props.saveStory(data.story)}
          />
          <FontAwesomeIcon className="story-edit-icon" icon={faPen} />
        </div>
        <h1 className="h6 text-muted">{this.props.completionStatus}</h1>
        <div className="question">{description}</div>
        <div className="text-input-container">
          <input
            autoFocus
            type="text"
            className="text-input"
            placeholder={t('Main characteristic...')}
            onChange={this.handleChange}
            value={this.state.value}
            maxLength={this.props.maxLength}
          />
          {suggestedTermsContainer}
        </div>
        <div className="actions">
          <button className="btn btn-link" onClick={skip}>
            Skip Question
          </button>
          <Link to={this.props.url + '/opposite'}>
            <button
              className="btn btn-primary btn-round btn-next"
              onClick={() => this.props.save(this.state.value)}
              disabled={!this.state.value}
            >
              Next <FontAwesomeIcon icon={faArrowRight} />
            </button>
          </Link>
        </div>
      </div>
    );
  }
}

export default translate('translations')(withRouter(Term));



// WEBPACK FOOTER //
// ./src/comparison-new/components/Pair/term.js